export type NoticeCategory = 'urgent' | 'service' | 'loisirs' | 'personnalise' | 'municipal'

export interface Notice {
  id: string
  category: NoticeCategory
  title: string
  description: string
  when: string
  ago: string
  context?: string
  unread: boolean
}

export const categoryLabels: Record<NoticeCategory, string> = {
  urgent: 'Urgent',
  service: 'Service',
  loisirs: 'Loisirs',
  personnalise: 'Personnalisé',
  municipal: 'Vie municipale',
}

export const notices: Notice[] = [
  {
    id: 'ebullition',
    category: 'urgent',
    title: 'Avis d’ébullition',
    description: 'Votre adresse est concernée. Faites bouillir l’eau une minute avant consommation.',
    when: 'Aujourd’hui · 14 h 30',
    ago: 'il y a 12 min',
    context: '4590, rue Bourgogne',
    unread: true,
  },
  {
    id: 'collecte',
    category: 'service',
    title: 'Collecte reportée',
    description: 'La collecte prévue jeudi aura lieu vendredi.',
    when: 'Hier · 16 h 10',
    ago: 'hier',
    context: 'Secteur B',
    unread: true,
  },
  {
    id: 'natation',
    category: 'personnalise',
    title: 'Rappel — Natation junior',
    description: 'Le cours d’Emma commence samedi à 10 h au Complexe aquatique de Brossard.',
    when: '21 août',
    ago: '21 août',
    context: 'Emma Bouchard',
    unread: false,
  },
  {
    id: 'req-2841',
    category: 'service',
    title: 'Votre demande a été mise à jour',
    description: 'Nid-de-poule — #REQ-2841 · Nouveau statut : En traitement',
    when: '28 août · 9 h 05',
    ago: '28 août',
    context: '4590, rue Bourgogne',
    unread: true,
  },
  {
    id: 'milo-rappel',
    category: 'personnalise',
    title: 'Rappel pour Milo',
    description: 'Vaccin prévu le 14 octobre 2026.',
    when: '20 août',
    ago: '20 août',
    context: 'Milo · carte animale',
    unread: false,
  },
  {
    id: 'inscriptions',
    category: 'loisirs',
    title: 'Inscriptions ouvertes',
    description: 'Les inscriptions à la programmation d’automne sont maintenant ouvertes.',
    when: '25 août',
    ago: '25 août',
    unread: false,
  },
  {
    id: 'travaux',
    category: 'service',
    title: 'Travaux boulevard Marie-Victorin',
    description: 'Circulation locale seulement jusqu’au 12 septembre.',
    when: '19 août',
    ago: '19 août',
    context: 'À 400 m de votre adresse',
    unread: false,
  },
  {
    id: 'conseil',
    category: 'municipal',
    title: 'Assemblée du conseil municipal',
    description: 'Prochaine assemblée ordinaire le 8 septembre à 19 h 30.',
    when: '14 août',
    ago: '14 août',
    unread: false,
  },
]

export const activeAlert = {
  title: 'Avis d’ébullition — votre adresse est touchée',
  address: '4590, rue Bourgogne',
  addressLabel: 'Adresse principale',
  since: 'Depuis aujourd’hui, 14 h 30',
  summary:
    'Un avis d’ébullition est actuellement en vigueur pour cette adresse enregistrée dans votre profil.',
  concerns: 'L’adresse 4590, rue Bourgogne est dans la zone touchée.',
  todo: 'Faites bouillir l’eau au moins une minute avant consommation, selon l’avis officiel de la Ville.',
  questions: ['Puis-je boire l’eau ?', 'Puis-je en donner à mon animal ?', 'Quand l’avis sera-t-il levé ?'],
}

export const resolvedAlert = {
  title: 'Avis d’ébullition levé — secteur B',
  detail: 'L’eau est de nouveau propre à la consommation depuis le 24 août à 16 h.',
}

export const avisChips = ['Mes alertes importantes', 'Non lus', 'Cette semaine', 'Paramètres']

export const avisQuestions = [
  'Pourquoi ai-je reçu cet avis ?',
  'Quels avis sont essentiels ?',
  'Comment changer mon numéro de téléphone ?',
  'Quelles adresses sont associées à mes alertes ?',
]

export interface ChannelPref {
  id: string
  label: string
  destination: string
  enabled: boolean
}

export const channelPrefs: ChannelPref[] = [
  { id: 'push', label: 'Notifications mobiles', destination: 'Application bciti+', enabled: true },
  { id: 'courriel', label: 'Courriel', destination: 'charlotte.bouchard@courriel.com', enabled: true },
  { id: 'sms', label: 'SMS', destination: '(450) •••-0184', enabled: false },
]

export interface TopicPref {
  id: string
  label: string
  description: string
  enabled: boolean
}

export const topicPrefs: TopicPref[] = [
  { id: 'collectes', label: 'Collectes', description: 'Rappels et changements de collecte', enabled: true },
  { id: 'loisirs', label: 'Loisir et culture', description: 'Inscriptions, rappels et changements', enabled: true },
  { id: 'travaux', label: 'Travaux et circulation', description: 'Travaux, fermetures et impacts locaux', enabled: true },
  { id: 'municipal', label: 'Vie municipale', description: 'Actualités et informations de la Ville', enabled: false },
  {
    id: 'personnalise',
    label: 'Services personnalisés',
    description: 'Informations liées aux services que vous utilisez',
    enabled: true,
  },
]

export const alertPlaces = [
  { id: 'principale', address: '4590, rue Bourgogne', label: 'Adresse principale' },
  { id: 'secondaire', address: '8125, boulevard Marie-Victorin', label: 'Deuxième propriété' },
]
